import clsx from "clsx";

export interface PillOption {
  value: string;
  label: string;
  disabled?: boolean;
  swatch?: string;
}

export interface PillGroupProps {
  options: PillOption[];
  value: string | null;
  onChange: (value: string) => void;
  "aria-label"?: string;
}

export function PillGroup({ options, value, onChange, ...aria }: PillGroupProps) {
  return (
    <div role="radiogroup" className="flex flex-wrap gap-2" {...aria}>
      {options.map((opt) => {
        const selected = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={opt.disabled}
            onClick={() => onChange(opt.value)}
            className={clsx(
              "h-10 min-w-10 px-4 rounded-full border text-sm font-medium transition-all duration-300 ease-physical",
              "hover:-translate-y-0.5 disabled:opacity-30 disabled:pointer-events-none disabled:translate-y-0",
              selected
                ? "border-accent bg-accent text-ink shadow-glow-accent"
                : "border-border bg-surface text-ink hover:border-accent/60"
            )}
          >
            {opt.swatch ? (
              <span className="flex items-center gap-2">
                <span
                  className="w-4 h-4 rounded-full border border-border"
                  style={{ backgroundColor: opt.swatch }}
                />
                {opt.label}
              </span>
            ) : (
              opt.label
            )}
          </button>
        );
      })}
    </div>
  );
}
